import gql from "graphql-tag";

// Time elapsed in hours
export const HUMIDITY_QUERY = gql`
query {
  currentHumidityMeasurements {
    value
    inventoryItem {
      id
      name
      code
    }
  }
}
`;
